import { render, staticRenderFns } from "./IconSignLanguage.vue?vue&type=template&id=9f906a14&"
import script from "./IconSignLanguage.vue?vue&type=script&lang=ts&"
export * from "./IconSignLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports